import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = { class: "portal mb-4" }
const _hoisted_2 = { class: "menu-bar mb-2" }
const _hoisted_3 = { class: "portal-header__content roba-container" }
const _hoisted_4 = { class: "portal-nav flex flex-align-end flex-justify-center" }
const _hoisted_5 = { class: "portal-main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_menu_button = _resolveComponent("menu-button")!
  const _component_my_environment_menu = _resolveComponent("my-environment-menu")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", {
        class: "portal-header",
        style: _normalizeStyle({ minHeight: _ctx.topBarHeight })
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            class: "roba-logo-link flex",
            to: _ctx.currentUser.roleName === _ctx.superAdmin ? {name: _ctx.PageNames.UserManagement} : {name: _ctx.PageNames.Dashboard }
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                class: "roba-logo",
                src: _imports_0
              }, null, -1)
            ]))]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("nav", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleMenu, (item) => {
              return (_openBlock(), _createBlock(_component_menu_button, {
                key: item.route.name,
                "menu-item": item
              }, null, 8, ["menu-item"]))
            }), 128))
          ]),
          _createVNode(_component_my_environment_menu)
        ])
      ], 4)
    ]),
    _createElementVNode("main", _hoisted_5, [
      _createVNode(_component_router_view)
    ])
  ]))
}